<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Edit Partner
            </h2>
        </template>

        <partner-form :partner="partner" :action="route('partners.update', partner.id)" button="Update"></partner-form>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout';
    import PartnerForm from './Form';

    export default {
        props: ['partner'],

        components: {
            AppLayout,
            PartnerForm,
        },
    }
</script>
